// Tek kaynak: rol etiketi (TR/EN), rozet rengi, yönetim hiyerarşisi, ops-dashboard
// auth guard grupları. Önceden TeamPage/ProfilePage/PortalLayout/UserManagement/App.js
// içinde 5+ ayrı yerde tekrarlanıyordu (FE-95: UserManagement'taki kopya company_admin
// case'ini hiç içermiyordu, ham rol string'i sızıyordu).
//
// ROLE_RANK ağırlıkları services/identity-service backend kuralıyla birebir aynı
// (bkz. CLAUDE.md "Role weights") — FE karşılaştırması BE ile aynı sonucu vermeli.
export const ROLE_RANK = { company_admin: 150, admin: 100, supervisor: 50, agent: 10 };

export const ROLE_TR = {
  company_admin: 'Şirket Admini',
  admin: 'Admin',
  supervisor: 'Süpervizör',
  agent: 'Temsilci',
};

export const ROLE_EN = {
  company_admin: 'Company Admin',
  admin: 'Admin',
  supervisor: 'Supervisor',
  agent: 'Agent',
};

export const ROLE_COLORS = {
  company_admin: '#E5A93B',
  admin: '#60a5fa',
  supervisor: '#a78bfa',
  agent: '#94a3b8',
};

export const translateRole = (role) => ROLE_TR[role] || role;
export const roleLabelEn = (role) => ROLE_EN[role] || role;
export const roleColor = (role) => ROLE_COLORS[role] || ROLE_COLORS.agent;

// actor hedef kullanıcıyı yönetebilir mi (create/update/delete) — yalnızca kendinden
// düşük rank'tekileri yönetebilir. bkz. identity-service userController.js aynı kural.
export const canManage = (actorRole, targetRole) => ROLE_RANK[actorRole] > ROLE_RANK[targetRole];

// Rol bazlı sayfa erişimi (2026-08-26, OPS_DASHBOARD_ROL_PAKET_ERISIM_TASARIMI): actorRole'ün
// ağırlığı minRole'ünkinden büyük veya eşit mi — "en düşük yeterli rol, üsttekiler dahil"
// modeli. minRole null/undefined ise herkes (giriş yapmış her rol) erişebilir.
export const hasMinRole = (actorRole, minRole) => {
  if (!minRole) return true;
  return (ROLE_RANK[actorRole] || 0) >= (ROLE_RANK[minRole] || 0);
};

// ops-dashboard'a giriş yapabilecek tüm roller (App.js KC init akışı).
export const ALL_OPS_ROLES = ['agent', 'supervisor', 'admin', 'company_admin'];

// /admin sayfasına yönlendirilen roller (agent → /agent, company_admin → /portal/dashboard,
// bu ikisi ayrı dallarda ele alınıyor — bu grup yalnızca /admin hedefi için).
export const OPS_ADMIN_PAGE_ROLES = ['admin', 'supervisor'];
